/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2LetterTaskIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2LetterTaskIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2LetterTaskIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 19,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#0E1F5C"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2LetterTaskIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 19 18"
 style={{'--as-1-K3lVT': alignSelf,'--mt-2-K3lVT': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-K3lVT': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-K3lVT': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-K3lVT': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-K3lVT': opacity,'--w-10-K3lVT': typeof width === 'number' ? `${width}px` : width,'--h-11-K3lVT': typeof height === 'number' ? `${height}px` : height,'--f-12-K3lVT': fill,'--a-7-K3lVT': isAnimated ? animation : "none",'--sd-8-K3lVT': isAnimated ? strokeDashoffset : 0,'--sd-9-K3lVT': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2LetterTaskIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M11.337.203a.67.67 0 00-.96 0l-8.821 9a.697.697 0 00-.186.354l-.678 3.461a.702.702 0 00.185.625.67.67 0 00.613.19l3.393-.693a.675.675 0 00.347-.189l8.821-9a.702.702 0 000-.979L11.337.202zm3.006 15.363l.205-.21c.46-.47.72-1.107.72-1.772V13.5c0-1.338-1.064-2.423-2.375-2.423-1.312 0-2.375 1.085-2.375 2.423v.084c0 .665.259 1.303.72 1.773l.205.21c-.294.23-.657.356-1.032.356H1.018c-.562 0-1.018.465-1.018 1.039C0 17.535.456 18 1.018 18h9.393c.918 0 1.8-.345 2.482-.964a3.69 3.69 0 002.481.964h2.608c.562 0 1.018-.465 1.018-1.038 0-.574-.456-1.039-1.018-1.039h-2.608c-.375 0-.737-.127-1.031-.357zm-1.79-2.066c0-.191.152-.346.34-.346.187 0 .34.155.34.346v.084a.435.435 0 01-.124.304l-.216.22-.216-.22a.434.434 0 01-.123-.304V13.5z"
 style={{'--f-12-K3lVT': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}